module.exports = "/_next/static/resources/life1-1d55a2b7f2b205ec6b1dc20548a2162c.webp";